import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMapboxComponent } from './simple-icons-mapbox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMapboxComponent ],
    exports:      [ SimpleIconsMapboxComponent ],
    bootstrap:    []
})
export class SimpleIconsMapboxModule {}
